import { render, staticRenderFns } from "./MarkdownMath.vue?vue&type=template&id=9f621c3a&scoped=true&"
import script from "./MarkdownMath.vue?vue&type=script&lang=js&"
export * from "./MarkdownMath.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownMath.vue?vue&type=style&index=0&id=9f621c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f621c3a",
  null
  
)

export default component.exports